const backend = {
    url: 'https://api.bike2work.rocks/dailyCommute'
};

export function getBackendUri() {
    return backend;
}
